export default __webpack_public_path__ + "images/fetal_heart_blue.72335cf22472ab28d7f179ceb3bc00af.png";